const TOKENS_NAME = 'tokens'

export const tokenService = {
  getToken: (): string | null => {
    const tokensStr = localStorage.getItem(TOKENS_NAME)
    return tokensStr ? JSON.parse(tokensStr) : null
  },

  updateTokens: (tokens: string): void => {
    localStorage.setItem(TOKENS_NAME, JSON.stringify(tokens))
  },

  removeToken: (): void => {
    localStorage.removeItem(TOKENS_NAME)
  },
}
